// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GlobalOutlinedSvg from "@ant-design/icons-svg/es/asn/GlobalOutlined";
import AntdIcon from '../components/AntdIcon';

var GlobalOutlined = function GlobalOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GlobalOutlinedSvg
  }));
};

GlobalOutlined.displayName = 'GlobalOutlined';
export default React.forwardRef(GlobalOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/GlobalOutlined.js
// module id = 1269
// module chunks = 0